import { useEffect } from 'react'

/**
 * Hook to handle Escape key presses.
 * Extracted from 6 duplicated patterns (DUP-2):
 * AssessmentRecoveryModal, AssessmentErrorModal, ValidationErrorModal,
 * CheatSheetDrawer, SlideOver, PracticeSession.
 *
 * @param callback - Called when Escape is pressed
 * @param enabled - Only listen when true (default: true)
 */
export function useEscapeKey(callback: () => void, enabled = true) {
  useEffect(() => {
    if (!enabled) return

    function handleEscape(event: KeyboardEvent) {
      if (event.key === 'Escape') {
        callback()
      }
    }

    window.addEventListener('keydown', handleEscape)
    return () => window.removeEventListener('keydown', handleEscape)
  }, [callback, enabled])
}
